// extracted by mini-css-extract-plugin
module.exports = {"ChatBody":"ChatBody_ChatBody__2LWnA","MessagesContainer":"ChatBody_MessagesContainer__1zDfh","fade":"ChatBody_fade__2Gthz"};